import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { IupacRegexCalc } from "../components/IupacRegexCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.iupac_tool_name()}
        toolPath="/iupac-to-regex"
      />
      <SciHeader title={m.iupac_h1()} intro={m.iupac_intro()} />

      <IupacRegexCalc />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.iupac_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.iupac_ex1(), m.iupac_ex2(), m.iupac_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.iupac_faq_q1(), a: m.iupac_faq_a1() },
          { q: m.iupac_faq_q2(), a: m.iupac_faq_a2() },
          { q: m.iupac_faq_q3(), a: m.iupac_faq_a3() },
          { q: m.iupac_faq_q4(), a: m.iupac_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
